<template lang="pug">
div
    el-dialog.modal-detalhe-duplicidade(
        :visible.sync='mostrarModal',
        :close-on-click-modal='false',
        :destroy-on-close='true',
        :show-close='false',
        fullscreen
    )
        .modal-detalhe-duplicidade__lista
            .modal-detalhe-duplicidade__lista__header
                h2.cursor-pointer(@click='fecharModal()')
                    i.el-icon-arrow-left.voltar
                    | {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.duplicidadeModalTitulo') }}

            .modal-detalhe-duplicidade__lista__content(v-if='dadosSelecionados')
                .modal-detalhe-duplicidade__territorio
                    h3 {{ dadosSelecionados.nomeTerritorio }}

                .modal-detalhe-duplicidade__status-tag(
                    :class='statusTagClass'
                )
                    i(:class='statusIconClass')
                    | {{ statusTagText }}

                .modal-detalhe-duplicidade__secao
                    span.modal-detalhe-duplicidade__secao__titulo {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.areaAnalisada') }}

                    .modal-detalhe-duplicidade__gleba
                        .modal-detalhe-duplicidade__gleba__nome
                            span.modal-detalhe-duplicidade__gleba__icone
                            | {{ dadosSelecionados.glebaOriginal.nome }}

                        .modal-detalhe-duplicidade__grid
                            .modal-detalhe-duplicidade__grid__item
                                span.modal-detalhe-duplicidade__grid__label {{ $t('mensagens.operacao.formularioGleba.areaHa') }}
                                span.modal-detalhe-duplicidade__grid__valor {{ formatarValorHa(dadosSelecionados.areaHa) }}

                .modal-detalhe-duplicidade__secao
                    span.modal-detalhe-duplicidade__secao__titulo {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.areasDuplicidadeIdentificada') }}

                    .modal-detalhe-duplicidade__gleba
                        .modal-detalhe-duplicidade__gleba__nome
                            span.modal-detalhe-duplicidade__gleba__icone.modal-detalhe-duplicidade__gleba__icone--duplicada
                            | {{ dadosSelecionados.glebaDuplicada.nome || dadosSelecionados.glebaDuplicada.codigoEmpreendimento || '--' }}

                        .modal-detalhe-duplicidade__grid
                            .modal-detalhe-duplicidade__grid__item
                                span.modal-detalhe-duplicidade__grid__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.refBacen') }}
                                span.modal-detalhe-duplicidade__grid__valor {{ dadosSelecionados.glebaDuplicada.refBacen || '--' }}
                            .modal-detalhe-duplicidade__grid__item
                                span.modal-detalhe-duplicidade__grid__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.dataEmissao') }}
                                span.modal-detalhe-duplicidade__grid__valor {{ dadosSelecionados.glebaDuplicada.dataEmissao || '--' }}
                            .modal-detalhe-duplicidade__grid__item
                                span.modal-detalhe-duplicidade__grid__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.dataVencimento') }}
                                span.modal-detalhe-duplicidade__grid__valor {{ dadosSelecionados.glebaDuplicada.dataVencimento || '--' }}
                            .modal-detalhe-duplicidade__grid__item
                                span.modal-detalhe-duplicidade__grid__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.estado') }}
                                span.modal-detalhe-duplicidade__grid__valor {{ dadosSelecionados.glebaDuplicada.uf || '--' }}
                            .modal-detalhe-duplicidade__grid__item
                                span.modal-detalhe-duplicidade__grid__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.codigoEmpreendimento') }}
                                span.modal-detalhe-duplicidade__grid__valor {{ dadosSelecionados.glebaDuplicada.codigoEmpreendimento || '--' }}
                            .modal-detalhe-duplicidade__grid__item
                                span.modal-detalhe-duplicidade__grid__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.areaFinanciamento') }}
                                span.modal-detalhe-duplicidade__grid__valor {{ formatarValorHa(dadosSelecionados.glebaDuplicada.areaFinanciamentoHa) }}
                            .modal-detalhe-duplicidade__grid__item
                                span.modal-detalhe-duplicidade__grid__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.inicioPlantio') }}
                                span.modal-detalhe-duplicidade__grid__valor {{ dadosSelecionados.glebaDuplicada.dataInicioPlantio || '--' }}
                            .modal-detalhe-duplicidade__grid__item
                                span.modal-detalhe-duplicidade__grid__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.fimPlantio') }}
                                span.modal-detalhe-duplicidade__grid__valor {{ dadosSelecionados.glebaDuplicada.dataFimPlantio || '--' }}
                            .modal-detalhe-duplicidade__grid__item
                                span.modal-detalhe-duplicidade__grid__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.inicioColheita') }}
                                span.modal-detalhe-duplicidade__grid__valor {{ dadosSelecionados.glebaDuplicada.dataInicioColheita || '--' }}
                            .modal-detalhe-duplicidade__grid__item
                                span.modal-detalhe-duplicidade__grid__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.fimColheita') }}
                                span.modal-detalhe-duplicidade__grid__valor {{ dadosSelecionados.glebaDuplicada.dataFimColheita || '--' }}
                            .modal-detalhe-duplicidade__grid__item
                                span.modal-detalhe-duplicidade__grid__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.finalidade') }}
                                span.modal-detalhe-duplicidade__grid__valor {{ dadosSelecionados.glebaDuplicada.finalidade || '--' }}
                            .modal-detalhe-duplicidade__grid__item
                                span.modal-detalhe-duplicidade__grid__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.atividade') }}
                                span.modal-detalhe-duplicidade__grid__valor {{ dadosSelecionados.glebaDuplicada.atividade || '--' }}
                            .modal-detalhe-duplicidade__grid__item
                                span.modal-detalhe-duplicidade__grid__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.modalidade') }}
                                span.modal-detalhe-duplicidade__grid__valor {{ dadosSelecionados.glebaDuplicada.modalidade || '--' }}
                            .modal-detalhe-duplicidade__grid__item
                                span.modal-detalhe-duplicidade__grid__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.produto') }}
                                span.modal-detalhe-duplicidade__grid__valor {{ dadosSelecionados.glebaDuplicada.produto || '--' }}

        .modal-detalhe-duplicidade__mapa
            mapa(
                :showStatesLayers='false',
                :mapLayersConfigs='layersMaps',
                :mapConfig='mapConfig',
                :height='"100%"',
                :idMapa='"mapaDetalheDuplicidade"',
                ref='mapa',
                :menuMaior='true',
                :doubleMapOnPage='true'
            )
</template>

<script>
import Mapa from '@/components/MapaLeaflet.vue';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos.js';

export default {
    name: 'ModalDetalheDuplicidade',
    components: {
        Mapa
    },

    data() {
        return {
            mostrarModal: false,
            dadosSelecionados: null,
            layersMaps: [],
            mapConfig: {
                controls: {
                    drawControl: false,
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    buscarCarControl: false,
                    bufferControl: false,
                    uploadFileControl: false,
                    ferramentasControl: true
                },
                historicoMonitoramento: false,
                inspecionar: false,
                diagnostico: false
            }
        };
    },

    computed: {
        statusTagClass() {
            if (!this.dadosSelecionados) return '';
            const status = this.dadosSelecionados.status;
            if (status === 'SUCESSO') return 'modal-detalhe-duplicidade__status-tag--sucesso';
            if (status === 'ATENCAO') return 'modal-detalhe-duplicidade__status-tag--atencao';
            return 'modal-detalhe-duplicidade__status-tag--alerta';
        },
        statusIconClass() {
            if (!this.dadosSelecionados) return '';
            return this.dadosSelecionados.status === 'SUCESSO'
                ? 'el-icon-circle-check'
                : 'el-icon-circle-close';
        },
        statusTagText() {
            if (!this.dadosSelecionados) return '';
            return this.$t(
                `mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.restricoesTag.${this.dadosSelecionados.status}`
            );
        }
    },

    methods: {
        abrirModal(data) {
            this.dadosSelecionados = data;
            this.layersMaps = [];
            this.mostrarModal = true;

            this.$nextTick(() => {
                if (data.geometria) {
                    this.layersMaps.push({
                        style: getEstiloGeometria('operacaoGleba'),
                        geoJson: data.geometria,
                        name: 'gleba'
                    });
                }
                if (data.geometriaTerritorio) {
                    this.layersMaps.push({
                        style: getEstiloGeometria('operacaoTerritorio'),
                        geoJson: data.geometriaTerritorio,
                        name: 'territorio'
                    });
                }
                if (data.glebaDuplicada && data.glebaDuplicada.geometria) {
                    this.layersMaps.push({
                        style: getEstiloGeometria('operacaoGlebaDuplicada'),
                        geoJson: data.glebaDuplicada.geometria,
                        name: 'glebaDuplicada'
                    });
                }
            });
        },

        fecharModal() {
            this.mostrarModal = false;
            this.dadosSelecionados = null;
            this.layersMaps = [];
        },

        formatarValorHa(valor) {
            if (valor == null) return '--';
            return `${valor} ha`;
        }
    }
};
</script>

<style lang="scss">
.modal-detalhe-duplicidade {
    .el-dialog__body {
        display: flex;
        padding: initial !important;
    }

    .el-dialog__header {
        padding: initial;
    }

    .modal-detalhe-duplicidade__lista {
        display: flex;
        flex-direction: column;
        min-width: 575px;
        gap: 20px;
        max-height: 100vh;
        padding: 20px 10px 20px 20px;

        .modal-detalhe-duplicidade__lista__header {
            .voltar {
                cursor: pointer;
                margin-right: 10px;
            }

            h2 {
                color: var(--primary-font-color);
            }
        }

        .modal-detalhe-duplicidade__lista__content {
            display: flex;
            flex-direction: column;
            gap: 20px;
            height: 90vh;
            overflow-y: auto;
        }
    }

    .modal-detalhe-duplicidade__territorio {
        h3 {
            font-weight: bold;
            color: var(--primary-font-color);
        }
    }

    .modal-detalhe-duplicidade__status-tag {
        display: inline-flex;
        align-items: center;
        padding: 2px 10px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 600;
        white-space: nowrap;
        width: fit-content;

        i {
            margin-right: 5px;
            font-size: 16px;
        }

        &--sucesso {
            background-color: #ecfcf4;
            color: #3d8c73;
            border: 1px solid #3d8c73;
        }

        &--alerta {
            background-color: #fff1f0;
            color: #df675b;
            border: 1px solid #df675b;
        }

        &--atencao {
            background-color: #f6efca;
            color: #c7b239;
            border: 1px solid #d7bc25;
        }
    }

    .modal-detalhe-duplicidade__secao {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .modal-detalhe-duplicidade__secao__titulo {
            font-size: 12px;
            color: #8a8a8a;
            font-weight: 600;
        }
    }

    .modal-detalhe-duplicidade__gleba {
        background-color: rgba(240, 240, 240, 0.5);
        border-radius: $default-border-radius;
        padding: 15px 20px;

        .modal-detalhe-duplicidade__gleba__nome {
            display: flex;
            align-items: center;
            gap: 8px;
            font-weight: bold;
            font-size: 14px;
            color: var(--primary-font-color);
            margin-bottom: 12px;
        }

        .modal-detalhe-duplicidade__gleba__icone {
            display: inline-block;
            width: 16px;
            height: 16px;
            background-color: #e6a817;
            border-radius: 3px;
            flex-shrink: 0;

            &--duplicada {
                background-color: #ff0000;
            }
        }
    }

    .modal-detalhe-duplicidade__grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;

        .modal-detalhe-duplicidade__grid__item {
            display: flex;
            flex-direction: column;
        }

        .modal-detalhe-duplicidade__grid__label {
            font-size: 12px;
            color: #8a8a8a;
            margin-bottom: 4px;
        }

        .modal-detalhe-duplicidade__grid__valor {
            font-weight: 600;
            font-size: 13px;
            color: var(--primary-font-color);
            word-break: keep-all !important;
        }
    }

    .modal-detalhe-duplicidade__mapa {
        width: 100%;
        height: 100vh;
        border-radius: 0;
    }
}
</style>
